import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ab763c7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "subscription-card-header" }
const _hoisted_2 = { class: "subscription-card-title" }
const _hoisted_3 = ["lang"]
const _hoisted_4 = {
  key: 1,
  class: "subscription-card-badge"
}
const _hoisted_5 = {
  key: 2,
  class: "subscription-card-qty-chip"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon sm remove-cart-item-logo",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  id: "icon-close"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.146 11.217a.5.5 0 1 0 .708.708l3.182-3.182 3.181 3.182a.5.5 0 1 0 .708-.708l-3.182-3.18 3.182-3.182a.5.5 0 1 0-.708-.708l-3.18 3.181-3.183-3.182a.5.5 0 0 0-.708.708l3.182 3.182-3.182 3.181z",
    "stroke-width": "0"
  })
], -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "text-danger small subscription-card-warning"
}
const _hoisted_9 = { class: "subscription-card-meta" }
const _hoisted_10 = { class: "subscription-card-chip" }
const _hoisted_11 = {
  key: 0,
  class: "subscription-card-chip"
}
const _hoisted_12 = {
  key: 1,
  class: "subscription-card-chip"
}
const _hoisted_13 = {
  key: 2,
  class: "subscription-card-chip subscription-card-chip--purchase"
}
const _hoisted_14 = {
  key: 1,
  class: "small text-muted mt-2 subscription-card-evaluation"
}
const _hoisted_15 = {
  key: 2,
  class: "subscription-card-qty-row"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "-", -1 /* HOISTED */))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "qty" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "+", -1 /* HOISTED */))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 3,
  class: "subscription-card-boost-hint"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subscription-card-divider" }, null, -1 /* HOISTED */))
const _hoisted_23 = {
  key: 4,
  class: "subscription-card-dates"
}
const _hoisted_24 = { class: "subscription-card-price" }
const _hoisted_25 = { class: "subscription-card-total" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["subscription-card", { 'subscription-card--inactive': $setup.is_inactive_quote_line }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h6", _hoisted_2, _toDisplayString($props.item.product_name || $props.item.product_id), 1 /* TEXT */),
      (!$props.quote && $props.item.promotion_badge)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "eshop-promo-badge",
            style: _normalizeStyle($props.item.promotion_badge.style),
            lang: $props.item.promotion_badge.title_lang || undefined
          }, _toDisplayString($props.item.promotion_badge.title), 13 /* TEXT, STYLE, PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true),
      ($setup.status_badge)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.status_badge), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (!$setup.qty_is_editable)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.item_qty), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (!$props.readonly && $setup.item_can_be_removed())
        ? (_openBlock(), _createElementBlock("div", {
            key: 3,
            class: "del grey-btn",
            onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('removeItem', $props.item)))
          }, _hoisted_7))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.best_max_user_not_achieved)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", null, _toDisplayString(_ctx.__("This product may be unsuitable for the number of user defined.")), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString(_ctx.__("Please check the product description.")), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.__($setup.item_unit)), 1 /* TEXT */),
      ($props.item.pricing_unit)
        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.__($props.item.pricing_unit)), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      ($props.item.estimated_setup_time)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.__("Est. setup time")) + ": " + _toDisplayString($props.item.estimated_setup_time) + " " + _toDisplayString(_ctx.__("H")), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      ($setup.is_one_time_purchase)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.__("Purchase")), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    ($props.evaluation_note && $props.item.trial_requested)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.__("Evaluation mode, not effective order")), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    ($setup.qty_is_editable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "qty-minus grey-btn",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.emit('minusQty', $props.item)))
          }, _hoisted_17),
          _createElementVNode("div", _hoisted_18, _toDisplayString($setup.item_qty), 1 /* TEXT */),
          _createElementVNode("div", {
            class: "qty-plus grey-btn",
            onClick: _cache[2] || (_cache[2] = $event => ($setup.emit('plusQty', $props.item)))
          }, _hoisted_20)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.boost_price_hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($setup.boost_price_hint), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _hoisted_22,
    (!$props.quote)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_23, [
          _createElementVNode("div", null, [
            _createElementVNode("dt", null, _toDisplayString(_ctx.__("Renewal Date")), 1 /* TEXT */),
            _createElementVNode("dd", null, _toDisplayString(_ctx.__($setup.renewal_date)), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("dl", _hoisted_24, [
      _createElementVNode("div", null, [
        _createElementVNode("dt", null, [
          _createTextVNode(_toDisplayString(_ctx.__("Setup and Purchase")), 1 /* TEXT */),
          ($setup.show_variable_price_marker && !$props.item.is_recurring)
            ? (_openBlock(), _createBlock($setup["PriceRuleTrigger"], {
                key: 0,
                rules: $setup.price_rules
              }, null, 8 /* PROPS */, ["rules"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("dd", {
          class: _normalizeClass($setup.amount_class($setup.install_cost))
        }, _toDisplayString($setup.ioi_format_currency($setup.install_cost || 0.0, $props.item.currency)), 3 /* TEXT, CLASS */)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("dt", null, _toDisplayString(_ctx.__("Unit Subscription")), 1 /* TEXT */),
        _createElementVNode("dd", {
          class: _normalizeClass($setup.amount_class($setup.enduser_price))
        }, _toDisplayString($setup.ioi_format_currency($setup.enduser_price || 0.0, $props.item.currency)), 3 /* TEXT, CLASS */)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("dt", null, [
          _createTextVNode(_toDisplayString(_ctx.__("Total Subscription")), 1 /* TEXT */),
          ($setup.show_variable_price_marker && $props.item.is_recurring)
            ? (_openBlock(), _createBlock($setup["PriceRuleTrigger"], {
                key: 0,
                rules: $setup.price_rules
              }, null, 8 /* PROPS */, ["rules"]))
            : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("dd", {
          class: _normalizeClass([$setup.amount_class($setup.item_total), $setup.is_eval ? 'linethrough' : ''])
        }, _toDisplayString($setup.ioi_format_currency($setup.item_total || 0.0, $props.item.currency)), 3 /* TEXT, CLASS */)
      ])
    ])
  ], 2 /* CLASS */))
}